export {
    DynamicIcon,
    IconsMap,
    IconAsComponentMap,
} from './dynamic-icon';

export type {
    IIconWithProps,
    TIconType, // todo: переименовать
} from './dynamic-icon';
